import { Sync } from '@mui/icons-material';
import { Button } from '@mui/material';
import { ReactComponent as Logo } from '../../../assets/GJ.svg';
import { syncScans } from '../../../services/dbService';
import './Header.css';

const Header = () => {
    const handleSync = () => {
        syncScans();
    }

    return (
        <header className='JoosHeader'>
            <Logo className='logo' />
            <Button onClick={() => handleSync()} className='sync-btn' variant='contained'>
                <Sync /> Sync
            </Button>
        </header>
    )
};

export default Header;